// Consecutivo del vendedor como se muestra: sus iniciales y su numero (JJ-34).
// El nombre llega completo; el "NA" es el apellido de quien se dio de alta solo
// con su nombre y no cuenta. Sin numero no hay folio. Un pedido que salio de dividir
// un prepedido lleva el folio de este mas su division (LM-45-1).
export function folioVendedor(nombre, consecutivo, division) {
  if (!consecutivo) return "";
  const numero = division ? `${consecutivo}-${division}` : consecutivo;
  const iniciales = String(nombre || "").trim().split(/\s+/)
    .filter((p) => p && p.toUpperCase() !== "NA")
    .map((p) => p.charAt(0).toUpperCase()).join("");
  return iniciales ? `${iniciales}-${numero}` : String(numero);
}

export default folioVendedor;
